import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { IconButton, Paper } from '@material-ui/core';

export const RowWrapper = styled.div`
    max-width: 940px;
    height: 44px;
    display: grid;
    grid-template-columns: 2fr repeat(2, 1fr) 180px;
    grid-column-gap: 40px;
    align-items: center;
    box-sizing: border-box;
    padding: 0 ${({ theme }) => theme.spacing * 6}px;
    margin: 0 auto ${({ theme }) => theme.spacing * 2}px;
    background-color: ${({ theme }) => theme.colors.paleBlue};
    border-radius: 6px;
    font-size: 14px;
    line-height: 44px;
    color: ${({ theme }) => theme.colors.blue};
    > p {
        margin: 0;
        opacity: .87;
    }
    > .MuiButtonBase-root  {
        justify-self: end;
        opacity: 0;
        padding: ${({ theme }) => theme.spacing}px;
    }
    :hover {
        background-color: #062b5414;
        > .MuiButtonBase-root  {
            opacity: 1;
        }
    }
`;

export const MobileItem = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-row-gap: 16px;
    background-color: ${({ theme }) => theme.colors.paleBlue};
    margin-bottom: ${({ theme }) => theme.spacing * 4}px;
    box-sizing: border-box;
    padding: ${({ theme }) => theme.spacing * 4}px;
    border-radius: 6px;
    > div > h3 {
        margin: 0;
        font-size: 12px;
        line-height: 24px;
        color: ${({ theme }) => theme.colors.darkBlueAlphaMedium};
    }
    > div:last-child {
        grid-area: 3 / 1 / 4 / 3;
    }
    > div > p {
        margin: 0;
        font-size: 14px;
        color: ${({ theme }) => theme.colors.blue};
        opacity: .87;
        word-break: break-all;
    }
`;

export const StyledPaper = styled(Paper)`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: ${({ theme }) => theme.colors.white};
    padding: ${({ theme }) => theme.spacing * 4}px ${({ theme }) => theme.spacing * 6}px;

    > button {
        height: 24px;
        border: none;
        padding: 0;
        background-color: unset;
        font-size: 14px;
        color: ${({ theme }) => theme.colors.blue};
        opacity: .87;
        outline: none;
        cursor: pointer;
    }
`;

export const StyledLink = styled(Link)`
    font-size: 14px;
    line-height: 24px;
    text-decoration: none;
    color: ${({ theme }) => theme.colors.blue};
    opacity: .87;
`;
